import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const IST_TIMEZONE = "Asia/Kolkata";

/** Format lifecycle timestamps in India (Kolkata) time. */
export function formatLifecycleCell(value: unknown): string {
  if (value == null || value === "") return "—";
  const raw = value as string | number | Date;
  // Parse as UTC when the value is an ISO instant (…Z) so IST conversion is correct.
  const parsed =
    typeof raw === "string" && /Z$/i.test(raw.trim())
      ? dayjs.utc(raw)
      : dayjs(raw);
  if (!parsed.isValid()) return "—";
  return parsed.tz(IST_TIMEZONE).format("DD MMM YYYY, hh:mm:ss A");
}
